import { twMerge } from "tailwind-merge";

interface BlackOverlayProps {
  isShown: boolean;
  message?: string;
  icon?: React.ReactNode;
}

export default function BlackOverlay({
  isShown,
  icon,
  message,
}: BlackOverlayProps) {
  return (
    <div
      className={twMerge(
        "pointer-events-none absolute inset-0 z-[1] flex h-full w-full flex-col items-center justify-center gap-3 rounded-lg bg-black/85 p-5 font-bold text-white opacity-0 backdrop-blur-md transition-all duration-300 will-change-[opacity]",
        isShown && "opacity-1 pointer-events-auto"
      )}
    >
      {message && <p className="text-center">{message}</p>}
      {icon && icon}
    </div>
  );
}
